import React, { useState , useEffect } from 'react';
import { Accordion, AccordionItem, Collapse, Button, Modal, ModalBody, ModalHeader, ModalFooter} from 'reactstrap';
import classnames from "classnames";
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { set_open_feature_not_available_modal } from '../../slices/Error_Modal/reducer';


const PlanDetailsModal = () => {
    const [modal_standard, setmodal_standard] = useState(false);
    const dispatch = useDispatch()
    const open_feature_not_available_modal = useSelector((state)=>state.Error_Modal.open_feature_not_available_modal)
            function tog_standard() {
                setmodal_standard(!modal_standard);
               dispatch( set_open_feature_not_available_modal(!modal_standard))
            }
  
    useEffect(() => {
        setmodal_standard(open_feature_not_available_modal);
    }, [open_feature_not_available_modal])
    
            
            
            
            return (



    <>
      {/* <div>
        <Button onClick={() => tog_standard()} style={{}}> Plan Detail</Button>
    </div> */}
    {/* Default Modal */}
    <Modal id="myModal"
            
            isOpen={modal_standard}
            toggle={() => {
                tog_standard();
            }}
        >
                <ModalHeader className="modal-title"
                    id="myModalLabel" toggle={() => {
                        tog_standard();
                    }} style={{ borderBottom: "1px solid #ddd", paddingBottom: "15px" }}>
                   {/* About Plan */}
                </ModalHeader>
                <ModalBody className='aboutplan'>
                <div className='s_feature'>
                <i className='bx bx-sad'></i> 
                <h5 className='heading' style={{ fontWeight: 'bold', textAlign: 'center' }}>
                Sorry !! This feature is not available with your current plan 
                    </h5>
                </div>
                    {/* <ul>
                        <li className=""><i className="ri-close-circle-fill fs-15 align-middle-circle-fill fs-15 align-middle"></i> Upload file : Not Available</li>
                        <li className=""><i className="ri-close-circle-fill fs-15 align-middle-circle-fill fs-15 align-middle"></i> Upload Q&A : Not Available</li>
                        <li className=""><i className="ri-close-circle-fill fs-15 align-middle-circle-fill fs-15 align-middle"></i> Website : Not Available</li>
                        <li className=""><i className="ri-close-circle-fill fs-15 align-middle-circle-fill fs-15 align-middle"></i> DbLink : Not Available</li>
                    </ul> */}
                        
                </ModalBody>
                <ModalFooter className='justify-content-center'>
                    {/* <div className="hstack gap-2">
                        <Link to="/pricing" className='btn btn-secondary'>Upgrade Plan</Link>
                    </div> */}
                </ModalFooter>
            </Modal>

    </>
  )
}

export default PlanDetailsModal